'use client'
import React from "react";
import AppSlider from "@/app/components/atomic/AppSlider";
import {IAppliedFilter, ISliderFilterConfig} from "@/app/models/auctor";
import {formatSliderValue} from "@/app/utils/filters-utils";

export default function FilterSlider({filterConfig, appliedFilter, handleChange, hideValue = false}: {
    filterConfig: ISliderFilterConfig,
    appliedFilter: IAppliedFilter,
    handleChange: any,
    hideValue?: boolean,
}) {
    const onChange = (newValue: any) => {
        handleChange(appliedFilter, newValue);
    }

    return (
        <div
            className="w-full flex flex-col justify-center gap-1"
        >
            {!hideValue &&
                <span className="font-semibold text-rm-blue">
                    {formatSliderValue(filterConfig, appliedFilter)}
                </span>
            }
            <AppSlider
                // @ts-ignore
                minValue={filterConfig.min_slider_value}

                // @ts-ignore
                maxValue={filterConfig.max_slider_value}
                // @ts-ignore
                value={appliedFilter.value}
                // @ts-ignore
                step={filterConfig.slider_step}
                showMarkers={true}
                showMedianValue={filterConfig.show_median_value ?? false}
                handleChange={onChange}
            />
        </div>
    )
}
